import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  type UseModalProps,
} from "@chakra-ui/react";
import { Trans } from "@lingui/macro";
import { type FunctionComponent, useRef } from "react";

export const ModalSettingsSmallScreen: FunctionComponent<UseModalProps> = (
  props,
) => {
  const okRef = useRef(null);

  return (
    <AlertDialog {...props} leastDestructiveRef={okRef}>
      <AlertDialogOverlay />
      <AlertDialogContent>
        <AlertDialogHeader>
          <Trans>Settings need bigger screen</Trans>
        </AlertDialogHeader>
        <AlertDialogBody>
          <Trans>To update workspace settings, use tablet or desktop.</Trans>
        </AlertDialogBody>
        <AlertDialogFooter>
          <Button ref={okRef} onClick={props.onClose}>
            <Trans>OK</Trans>
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
